import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AnsweredQuestionState {
    answerText: string[];
    selectedChoice: number[];
    answered: number[];
    duration: number[];
    markeds?: number[];
}

const initialState: AnsweredQuestionState = {
    answerText: [], /* answer text based on the index, for fill in the blanks and sentence arrangement */
    selectedChoice: [], /* selected choice id based on the index, for multiple choice*/
    answered : [], /* list of answered question index */
    duration: [], /* time taken to answer the question */
    markeds: [], /* list of markeds question index */
}

export const answeredQuestionSlice = createSlice({
    name: 'answeredQuestion',
    initialState,
    reducers: {
        setAnsweredQuestion: (state, action: PayloadAction<AnsweredQuestionState>) => {
            state.answerText = action.payload.answerText;
            state.selectedChoice = action.payload.selectedChoice;
            state.answered = action.payload.answered;
            state.duration = action.payload.duration;
            state.markeds = state.markeds;
        },
        setMarkeds: (state, action: PayloadAction<number[]>) => {
            state.markeds = action.payload;
        },
    }
});

export const { setAnsweredQuestion, setMarkeds } = answeredQuestionSlice.actions;

export default answeredQuestionSlice.reducer;